if (!customElements.get('lazy-video')) {
  // Videos load only when near the viewport and pause when they leave it; a horizontally clipped
  // slider slide counts as out of view, so only visible slides play.
  const observer = new IntersectionObserver(
    (entries) => {
      for (const { target, isIntersecting } of entries) target.closest('lazy-video')?.toggle(isIntersecting);
    },
    { rootMargin: '200px' }
  );

  // One shared dialog plays an expandable video full size, with sound and controls.
  const openVideoModal = (src, poster) => {
    let dialog = document.querySelector('dialog.video-modal');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'video-modal';
      dialog.innerHTML =
        '<button type="button" class="video-modal__close" aria-label="Close" autofocus>&times;</button>' +
        '<video class="video-modal__video" controls playsinline></video>';
      document.body.append(dialog);
      dialog.querySelector('.video-modal__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        const video = dialog.querySelector('video');
        video.pause();
        video.removeAttribute('src');
        video.load();
        document.documentElement.style.removeProperty('overflow');
      });
    }

    const video = dialog.querySelector('video');
    video.src = src;
    video.poster = poster || '';
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    video.play()?.catch(() => {});
  };

  customElements.define(
    'lazy-video',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        observer.observe(this.video);
        if (!this.hasAttribute('expandable')) return;
        // expandable="<selector>" makes the whole card a tap target, since captions and handles overlay the video.
        const area = this.closest(this.getAttribute('expandable') || 'lazy-video') || this.video;
        area.addEventListener('click', (event) => {
          if (event.target.closest('a, button, input, select, label, form')) return;
          this.open();
        });
      }

      disconnectedCallback() {
        if (this.video) observer.unobserve(this.video);
      }

      toggle(visible) {
        const { poster } = this.video.dataset;
        if (visible && poster && !this.video.poster) this.video.poster = poster;
        if (visible) this.play();
        else this.video.pause();
      }

      source() {
        const { srcSmall, srcLarge } = this.video.dataset;
        const large = window.matchMedia('(min-width: 768px)').matches;
        return (large ? srcLarge : srcSmall) || srcLarge || srcSmall;
      }

      play() {
        const { video } = this;
        if (!video.getAttribute('src')) video.src = this.source();
        video.play()?.catch(() => {});
      }

      open() {
        this.video.pause();
        openVideoModal(this.source(), this.video.dataset.poster);
      }
    }
  );
}
